import { Link, useLocation, useNavigate } from "react-router-dom";
import { NAV_LINKS, LEGAL } from "@/data/content";
import { scrollToSection } from "./SmoothScroll";
import { useConsent } from "./ConsentProvider";

export const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { openSettings } = useConsent();
  const go = (e, id) => {
    e.preventDefault();
    if (pathname !== "/") navigate(`/#${id}`);
    else scrollToSection(id);
  };

  return (
    <footer data-testid="site-footer" className="border-t border-navy/10 px-5 pb-10 pt-16 sm:px-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-12 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <img src="/images/logo-full.webp" alt="KeepThis! — Keep the memory. Toss the clutter." loading="lazy" width="1177" height="781" className="h-28 w-auto" />
          <p data-testid="footer-tagline" className="mt-5 font-heading text-lg font-extrabold text-navy">Keep the memory. Toss the clutter.</p>
        </div>
        <nav aria-label="Footer" className="flex flex-col gap-3">
          {NAV_LINKS.map((l) => (
            <a key={l.id} href={`/#${l.id}`} data-testid={`footer-${l.testId}`} onClick={(e) => go(e, l.id)} className="nav-link w-fit font-heading font-bold text-navy">
              {l.label}
            </a>
          ))}
        </nav>
      </div>
      <div className="mx-auto mt-14 flex max-w-7xl flex-col gap-5 border-t border-navy/10 pt-8 text-sm text-navy/75 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} KeepThis!</p>
        <ul aria-label="Legal" className="flex flex-wrap gap-x-6 gap-y-2">
          {LEGAL.map((l) => (
            <li key={l.label}>
              <Link to={l.path} data-testid={l.testId} className="nav-link text-navy/80 hover:text-navy">{l.label}</Link>
            </li>
          ))}
          <li>
            <button type="button" data-testid="footer-cookie-settings" onClick={openSettings} className="nav-link text-navy/80 hover:text-navy">Cookie Settings</button>
          </li>
        </ul>
      </div>
    </footer>
  );
};
